const RegisterView = () => import("@/views/auth/RegisterView");
const LoginView = () => import("@/views/auth/LoginView");
const ForgotPasswordView = () => import("@/views/auth/ForgotPasswordView");
const ResetPasswordView = () => import("@/views/auth/ResetPasswordView");
const VerificationView = () => import("@/views/auth/VerificationView");
const AcceptTerms = () => import("@/views/auth/AcceptTerms");
import {useAuthStore} from "@/stores/auth.store";
import GuestLayout from "@/layouts/GuestLayout";

const routes = [
    {
        path: '/register',
        name: 'register',
        component: RegisterView,
        meta: {
            title: 'Rejestracja',
            layout:  {
                component: GuestLayout,
                props: {
                    displayLogo: true,
                }
            },
        }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: {
            title: 'Logowanie',
            layout: {
                component: GuestLayout,
                props: {
                    displayLogo: true,
                }
            }
        }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPasswordView,
        meta: {
            title: 'Przypomnij hasło',
            layout: {
                component: GuestLayout,
                props: {
                    additionalClass: "auth__box--reset",
                    displayLogo: false,
                }
            }
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: {
            beforeRouteEnter(to, from, next) {
                const authStore = useAuthStore();
                authStore.logout();
            }
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: ResetPasswordView,
        meta: {
            title: 'Zmiana hasła',
            layout: {
                component: GuestLayout,
                props: {
                    additionalClass: "auth__box--reset",
                    displayLogo: false,
                }
            }
        }
    },
    {
        path: '/verification',
        name: 'verification',
        component: VerificationView,
        meta: {
            title: 'Weryfikacja konta',
            layout: {
                component: GuestLayout,
                props: {
                    additionalClass: "auth__box--reset",
                    displayLogo: false,
                }
            }
        }
    },
    {
        path: '/accept-of-terms',
        name: 'accept-of-terms',
        component: AcceptTerms,
        meta: {
            title: 'Akceptacja regulaminu',
            authorize: [true],
            layout: {
                component: GuestLayout,
                props: {
                    additionalClass: "auth__box",
                    displayLogo: false,
                }
            }
        }
    },
]

export default routes;
